import _ from "lodash";
import React, { PureComponent } from "react";

import classes from "./Groupedview.scss";

import I18nHOC from "UIComponents/I18nHOC";
import EmptyView from "UIComponents/EmptyView/EmptyView";
import LockOverlay from "UIComponents/LockOverlay";
import BenchmarkView from "UIComponents/BenchmarkView";
import EmptyField from "UIComponents/EmptyField";
import { Button } from "@toddle-edu/ds-web";

import classNames from "classnames";
import { NoUnitFoundIllustration } from "@toddle-edu/ds-theme";
import { getLabelWithArchivedText } from "Utils";

const emptyFieldStyle = {
  containerStyle: {
    border: 0,
  },
};
class Groupedview extends PureComponent {
  constructor(props) {
    super(props);
  }

  getEmptyComponent = () => {
    const {
      t,
      onAddNewClicked,
      parentNode,
      emptyTextSelectSubgroupLocale,
      plannerLabel,
      lockFieldForSchoolGroups,
    } = this.props;
    return lockFieldForSchoolGroups ? (
      <EmptyView
        emptyImageUrl={NoUnitFoundIllustration}
        emptyHeaderText={t("common:no_label_added", {
          label: "Content skills",
        })}
        size="small"
      />
    ) : (
      <EmptyField
        title={`${t(emptyTextSelectSubgroupLocale, {
          label: parentNode.label,
          plannerLabel,
        })}`}
        onAddNewClick={() => onAddNewClicked(parentNode)}
        showAdd={true}
        containerStyle={emptyFieldStyle.containerStyle}
      />
    );
  };

  render() {
    const {
      props: {
        lockedField,
        parentNode,

        rootNodeDepth,
        onAddClicked,

        t,
        lockFieldForSchoolGroups = false,
        nestedGroupedValue,
        showEditButtonAtHeader,
        innerContainerStyle,

        // only used for new single page unit view
        nodes,
        rootNodeIds,
        mode,
      },
    } = this;

    const isEditMode = mode === "edit";

    const mainContainerClass = classNames({
      [classes.mainContentContainer]: true,
      [classes.lockContainer]: lockFieldForSchoolGroups,
    });
    const isDataEmpty = _.isEmpty(nestedGroupedValue) && _.isEmpty(rootNodeIds);

    return (
      <div className={classes.mainContainer}>
        {!showEditButtonAtHeader && (
          <div className={classes.headerContainer}>
            <div className={classes.headerLabel}>
              {getLabelWithArchivedText({
                t,
                label: _.get(parentNode, "label", ""),
                isArchived: _.get(parentNode, "isArchived", false),
              })}
            </div>

            {!isDataEmpty && isEditMode ? (
              <Button
                size="medium"
                variant="outlined-subtle"
                disabled={!!lockedField}
                onClick={() => onAddClicked(parentNode)}
              >
                {t("edit")}
              </Button>
            ) : null}
          </div>
        )}
        <div className={mainContainerClass}>
          {!_.isEmpty(nestedGroupedValue) ? (
            <div className={classes.innerContainer} style={innerContainerStyle}>
              <BenchmarkView
                value={nestedGroupedValue}
                startDepth={rootNodeDepth}
                mode={"view"}
              ></BenchmarkView>
            </div>
          ) : (
            this.getEmptyComponent()
          )}
          {lockedField && isEditMode && (
            <LockOverlay userInfo={_.get(lockedField, "userInfo", {})} />
          )}
        </div>
      </div>
    );
  }
}

export default I18nHOC({ resource: "common" })(Groupedview);
